import api from '../config/api';

const productService = {
  async getAll() {
    const response = await api.get('/api/products');
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/api/products/${id}`);
    return response.data;
  },

  async getDetails(id, { admin = true } = {}) {
    const response = await api.get(`/api/products/${id}/details`, {
      params: admin ? { admin: true } : {},
    });
    return response.data;
  },

  async create(productData) {
    const response = await api.post('/api/products', productData);
    return response.data;
  },

  async update(id, productData) {
    const response = await api.put(`/api/products/${id}`, productData);
    return response.data;
  },

  async delete(id) {
    const response = await api.delete(`/api/products/${id}`);
    return response.data;
  },

  async setStoreVisibility(id, visible) {
    const response = await api.patch(`/api/products/${id}/store-visibility`, { visible });
    return response.data;
  },

  async uploadImage(productId, imageFile) {
    const formData = new FormData();
    formData.append('file', imageFile);
    
    const response = await api.post(`/api/products/${productId}/images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async exportToExcel() {
    const response = await api.get('/api/products/export/excel', {
      responseType: 'blob',
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `products-${new Date().toISOString()}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
};

export default productService;
